import { t } from "i18next";
import emptyFieldValidate from "../../../shared/empty.validate";

export type TErrors = {
  [key: string]: string | undefined;
};

const LearnMoreValidator = (FormValues: Record<string, any>) => {
  let errors: TErrors = {
    title: undefined,
    bodyText: undefined,
  };

  errors.title = emptyFieldValidate(FormValues.title, t("core:common:title"));

  errors.bodyText = emptyFieldValidate(
    FormValues.bodyText,
    t("core:common:body")
  );

  return errors;
};

export default LearnMoreValidator;
